import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Language, SharedService } from '@app/core';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  standalone: false,
})
export class LanguageComponent implements OnInit {
  currentLanguage: string;
  languagesSubject: BehaviorSubject<Language[]> = this.sharedService.languagesSubject;

  constructor(private sharedService: SharedService) {}

  ngOnInit(): void {
    this.currentLanguage = this.sharedService.currentLanguage?.split('-')[0];
  }

  changeLang() {
    this.sharedService.changeLanguage(this.currentLanguage);
  }
}
